(function (angular) {

    "use strict";

    angular
        .module('harriApp')
        .controller('CostSavingController', CostSavingController);

    CostSavingController.$inject = ['$rootScope', '$scope', '$stateParams', '$filter', 'hUser', '$modal', 'hEvent', 'appLayoutViewService'];

    function CostSavingController($rootScope, $scope, $stateParams, $filter, hUser, $modal, hEvent, appLayoutViewService) {
        $scope.symbol = '£';
        $scope.inputs = {
            hires: 1200,
            employees: 1000,
            costPerHire: 1000,
            annualTurnover: 1200 / 1000 * 100,
            dayChurn: 44
        };

        $scope.calculatedValues = {};

        $scope.$watchCollection('inputs', function (newValue) {
            if (typeof parseFloat(newValue) === 'number') {
                $scope.calculatedValues.annualHiringCost = (newValue.hires * newValue.costPerHire).toFixed(2);
                $scope.calculatedValues.dayChurnCost = (newValue.hires * newValue.costPerHire * newValue.dayChurn / 100).toFixed(2);
                $scope.calculatedValues.savings = ($scope.calculatedValues.dayChurnCost / 100 * 10).toFixed(2);
                $scope.calculatedValues.totalOperationalHoursCost = (15 * 5 * newValue.hires).toFixed(2);
                $scope.calculatedValues.operationalHoursSaved = (5 * newValue.hires - newValue.hires).toFixed(2);
                $scope.calculatedValues.saving = ($scope.calculatedValues.totalOperationalHoursCost - $scope.calculatedValues.totalOperationalHoursCost / 5).toFixed(2);
            }
        });

        $scope.$watch('inputs.employees', function (newValue, oldValue) {
            if (typeof parseFloat(newValue) === 'number' && newValue != oldValue) {
                $scope.inputs.hires = Math.round($scope.inputs.annualTurnover * $scope.inputs.employees / 100);
                $scope.inputs.employees = Math.round(newValue);
            }
        });

        $scope.$watch('inputs.annualTurnover', function (newValue, oldValue) {
            if (typeof parseFloat(newValue) === 'number' && newValue != oldValue) {
                $scope.inputs.hires = Math.round($scope.inputs.annualTurnover * $scope.inputs.employees / 100);
            }
        });

        $rootScope.$on('user_updated', function (event) {
            $scope.isLoggedIn = hUser.isLoggedIn();
            $scope.isEmployer = hUser.isEmployer();
        });

        Utils.cookieBlockHandler();

        $(document).on("scroll.header2018", function () {
            if ($(this).scrollTop() > 70) {
                $(".header2018").addClass("fixed");
            } else {
                $(".header2018").removeClass("fixed");
            }
        });

        $scope.pageVersion = 'UK';
        $scope.isMobile = $(window).width() < 768;

        $scope.scheduleDemo = function (source) {
            var data = "";
            var analyticsData = $.extend({
                label: source,
                category: "salesRequest"
            }, data);

            hEvent.track('demo_request', analyticsData);

            var modalData = function () {
                return {
                    source: source,
                    pageVersion: $scope.pageVersion,
                    isMobile: $scope.isMobile,
                    type: 'demo_request'
                };
            };
            ngLandingPagesUtils.handleRequestDemoClick(modalData);
        };

        $scope.isSideBarExpanded = function () {
            return appLayoutViewService.isSideBarExpanded();
        };

        $scope.getToggleSource = function () {
            return appLayoutViewService.getToggleSource();
        };

        hUser.init()
            .then(function () {
            appLayoutViewService.updateBrandTheme();
        });
    }
})(angular);
